export default __webpack_public_path__ + "static/media/gallery_04.98f64f12.jpg";